import { StatsEntityEnum } from './entity.enum';
import { StatsAttributionServiceInterface } from '../../service/stats-attribution/service.interface';
import { uuidGenerate } from '../../helper/uuid/generate';
import { BrowserStorageLocalServiceInterface } from '../../service/browser-storage-local/service.interface';

export class StatsAttribution implements StatsAttributionServiceInterface {
  /**
   * Key to use to identify stats attribution values
   */
  private static readonly KEY: string = 'pf-attribution[{entityName}-{id}]';

  /**
   *
   * @param authenticationAttributionId
   */
  constructor(private browserStorageService: BrowserStorageLocalServiceInterface) {}

  /**
   * @inheritDoc
   */
  public push(entityName: StatsEntityEnum, id: string): string {
    const uuid = uuidGenerate();
    this.browserStorageService.setData(this.getKey(entityName, id), uuid);

    return uuid;
  }

  /**
   * @inheritDoc
   */
  public pop(entityName: StatsEntityEnum, id: string): string {
    const key = this.getKey(entityName, id);
    const uuid = <string>this.browserStorageService.getData(key);

    if (uuid) {
      this.browserStorageService.removeData(key);
      return uuid;
    }

    return null;
  }

  /**
   * Get the key from the inputted ID
   */
  private getKey(entityName: StatsEntityEnum, id: string): string {
    return StatsAttribution.KEY.replace('{entityName}', entityName).replace('{id}', id);
  }
}
